import React from 'react';

interface IProps {
  size?: string;
}

const ArrowBack: React.FC<IProps> = ({ size }) => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none">
        <path d="M32.0013 5.8333C17.2737 5.83329 5.33464 17.7724 5.33464 32.5C5.33464 47.2275 17.2737 59.1666 32.0013 59.1666C46.7289 59.1666 58.668 47.2276 58.668 32.5C58.668 17.7724 46.7289 5.8333 32.0013 5.8333Z" stroke="#304497" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M32 21.8333L21.3333 32.5L32 43.1666" stroke="#304497" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M42.668 32.5L21.3346 32.5" stroke="#304497" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  );
};

export default ArrowBack;
